// extracted by mini-css-extract-plugin
export var circle = "_2d-2";
export var icon = "_2d-a";
export var iconHighlight = "_2d-0";
export var lg = "_2d-8";
export var md = "_2d-7";
export var outline = "_2d-4";
export var sm = "_2d-6";
export var square = "_2d-1";
export var xl = "_2d-9";
export var xs = "_2d-5";
export var xxs = "_2d-3";